import { format, formatDistanceToNow, parseISO, isValid } from 'date-fns';

// ----------------------------------------------------------------------

export function fDate(date) {
  return format(new Date(date), 'dd MMM yyyy');
}

export function fDate1(date) {
  return format(new Date(date), 'dd MMM, yyyy');
}

export function fDateTime(date) {
  return format(new Date(date), 'dd MMM yyyy HH:mm');
}

export function fDateTime3(date) {
  return format(new Date(date), 'dd MMM yyyy, hh:mm:ssa');
}

export function fDateTime1(date) {
  return format(new Date(date), 'dd MMM, yyyy/hh:mm:ss a');
}
export function fDateTime2(date) {
  return format(new Date(date), 'yyyy-MM-dd#HH:mm:ss').replace('#', 'T');
}

export function fDateTime4(date) {
  return format(new Date(date), 'yyyy-MM-dd#HH:mm').replace('#', 'T');
}

export function fDate2(date) {
  return format(new Date(date), 'yyyy-MM-dd');
}

export function fDate3(date) {
  return format(new Date(date), 'MMM yyyy');
}

export function fDateNew(date) {
  if (!date) return 'NA';

  let parsed;

  // ✅ Case 1: YYYY-MM (month & year only)
  if (typeof date === 'string' && /^\d{4}-\d{2}$/.test(date)) {
    parsed = parseISO(`${date}-01`);
    return isValid(parsed) ? format(parsed, 'MMM yyyy') : 'NA';
  }

  // ✅ Case 2: Any full date (YYYY-MM-DD, ISO, timestamp string)
  parsed = parseISO(date);

  if (!isValid(parsed)) {
    // fallback for timestamps / other formats
    parsed = new Date(date);
  }

  return isValid(parsed) ? format(parsed, 'dd MMM yyyy') : 'NA';
}

export function fDateTimeSuffix(date) {
  return format(new Date(date), 'dd/MM/yyyy hh:mm p');
}

export function fToNow(date) {
  return formatDistanceToNow(new Date(date), {
    addSuffix: true
  });
}
